import { useLocation } from "react-router-dom";
import { useAppSelector } from "@/redux/hooks";

export default function Footer() {
  const location = useLocation();
  const tenant = useAppSelector((state) => state.tenant.loginTenant);

  if (location.pathname === "/checkout") return null;

  const year = new Date().getFullYear();
  const name = tenant?.Name || "";

  return (
    <footer className="fixed bottom-0 z-20 w-full border-t border-checkout-hairline bg-checkout-bg/80 px-6 py-4 backdrop-blur-md">
      <p className="text-center text-sm text-checkout-muted">
        ©{year} {name}
      </p>
    </footer>
  );
}
